import { render, staticRenderFns } from "./WhatsAppButton.vue?vue&type=template&id=59421918&scoped=true"
import script from "./WhatsAppButton.vue?vue&type=script&lang=js"
export * from "./WhatsAppButton.vue?vue&type=script&lang=js"
import style0 from "./WhatsAppButton.vue?vue&type=style&index=0&id=59421918&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59421918",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59421918')) {
      api.createRecord('59421918', component.options)
    } else {
      api.reload('59421918', component.options)
    }
    module.hot.accept("./WhatsAppButton.vue?vue&type=template&id=59421918&scoped=true", function () {
      api.rerender('59421918', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/WhatsAppButton.vue"
export default component.exports